import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {
    CommunicationConfigurationEmailSenderModel
} from "../../../api/entity/communicationConfigurationEmailSender.model";

@Injectable({
    providedIn: 'root'
})
export class CommunicationConfigurationEmailSenderRepository extends AbstractRepositoryV2<CommunicationConfigurationEmailSenderModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('CommunicationConfigurationEmailSender', serviceElementsFactory, injector);
    }
}